export const getImages = (imageName) => {
    const image = require(`../../assets/img/${imageName}`);
    return image;
}

export const LazyImage = ({ src, alt }) => {
    return (
            <img src={src} alt={alt} />
    );
};
export const teamImages = require.context('../../assets/img/team', false, /\.(png|jpe?g|svg)$/);